export const USER_ROLES = {
  ADMIN: 'ADMIN',
  USER: 'USER',
}

export const isAdmin = () => {
  const user_role = localStorage.getItem('user_role')
  return user_role == USER_ROLES.ADMIN
}
